(function () {
  function isTestMode() {
    return String(sessionStorage.getItem('pm_access_mode') || '')
      .toUpperCase() === 'TEST';
  }

  function hidePaymentActions() {
    if (!isTestMode()) return;

    document.querySelectorAll(
      '.accelerated-checkout-block,' +
      '.cart__checkout-button,' +
      '.additional-checkout-buttons,' +
      'shopify-accelerated-checkout,' +
      'shopify-accelerated-checkout-cart,' +
      '[name="checkout"],' +
      '#checkout'
    ).forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
      el.setAttribute('aria-hidden', 'true');
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!isTestMode()) return;
      if (!event.target || !event.target.closest) return;

      var target = event.target.closest(
        '.accelerated-checkout-block,' +
        '.cart__checkout-button,' +
        '.additional-checkout-buttons,' +
        '[name="checkout"],' +
        '#checkout'
      );

      if (target) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  function startPaymentGuard() {
    hidePaymentActions();

    new MutationObserver(function () {
      hidePaymentActions();
    }).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startPaymentGuard
    );
  } else {
    startPaymentGuard();
  }
})();


(function () {
  function isTestMode() {
    return String(sessionStorage.getItem('pm_access_mode') || '')
      .toUpperCase() === 'TEST';
  }

  function removeTestCartNotices() {
    document
      .querySelectorAll('[data-pm-test-cart-notice="true"]')
      .forEach(function (notice) {
        notice.remove();
      });
  }

  function createTestCartNotice() {
    var notice = document.createElement('div');

    notice.setAttribute(
      'data-pm-test-cart-notice',
      'true'
    );

    notice.innerHTML =
      '<div style="font-weight:700;font-size:16px;margin-bottom:8px;">' +
      'MODE TEST — COMMANDE NON PAYABLE' +
      '</div>' +
      '<div style="line-height:1.55;">' +
      'Vous pouvez constituer librement votre panier afin de simuler une commande.<br>' +
      '<strong>Aucun paiement ne peut être effectué avec un code TEST.</strong><br><br>' +
      'Les minimums de commande et les conditions de livraison propres à chaque domaine ' +
      's’appliqueront lors d’une commande réelle.<br>' +
      'Retrouvez leur détail dans l’onglet «&nbsp;Conditions de Commande et de Livraison&nbsp;» ' +
      'ou en cliquant sur ' +
      '<a href="/pages/frais-de-livraison-1" class="cse-rule-button cse-rule-button--unmet" style="vertical-align:middle;margin:0 0.15rem;">VOIR LA RÈGLE</a>.' +
      '</div>';

    notice.style.cssText =
      'display:block!important;' +
      'visibility:visible!important;' +
      'opacity:1!important;' +
      'width:100%!important;' +
      'max-width:100%!important;' +
      'margin:0 0 14px 0!important;' +
      'padding:18px 20px!important;' +
      'border:1px solid rgba(0,0,0,.20)!important;' +
      'border-radius:6px!important;' +
      'background:#f7f7f5!important;' +
      'color:#1d1d1d!important;' +
      'font-size:14px!important;' +
      'line-height:1.45!important;' +
      'box-sizing:border-box!important;' +
      'text-align:left!important;' +
      'flex:none!important;';

    return notice;
  }

  function getOpenCartDialog() {
    var components =
      document.querySelectorAll('cart-drawer-component');

    for (var i = 0; i < components.length; i++) {
      var component = components[i];

      var dialog = component.querySelector('dialog');

      if (!dialog) {
        continue;
      }

      if (
        dialog.open === true ||
        dialog.hasAttribute('open')
      ) {
        return dialog;
      }
    }

    return null;
  }

  function placeTestCartNotice() {
    if (!isTestMode()) {
      removeTestCartNotices();
      return;
    }

    var dialog = getOpenCartDialog();

    if (!dialog) {
      removeTestCartNotices();
      return;
    }

    /* PM TEST : defilement mobile complet, sans effet sur les autres acces. */
    if (
      window.matchMedia &&
      window.matchMedia('(max-width: 749px)').matches
    ) {
      dialog.setAttribute('cart-summary-sticky', 'false');
    }

    var summary =
      dialog.querySelector('.cart-drawer__summary');

    if (!summary) {
      return;
    }

    var existing =
      summary.querySelector(
        '[data-pm-test-cart-notice="true"]'
      );

    if (existing) {
      return;
    }

    removeTestCartNotices();

    var notice = createTestCartNotice();

    var cartCtas =
      summary.querySelector('.cart__ctas');

    if (cartCtas) {
      summary.insertBefore(
        notice,
        cartCtas
      );
      return;
    }

    summary.appendChild(notice);
  }

  function refreshTestCartNotice() {
    window.setTimeout(placeTestCartNotice, 0);
    window.setTimeout(placeTestCartNotice, 50);
    window.setTimeout(placeTestCartNotice, 150);
    window.setTimeout(placeTestCartNotice, 300);
    window.setTimeout(placeTestCartNotice, 600);
    window.setTimeout(placeTestCartNotice, 1000);
  }

  function startTestCartNotice() {
    refreshTestCartNotice();

    document.addEventListener(
      'click',
      function () {
        refreshTestCartNotice();
      },
      true
    );

    new MutationObserver(function () {
      refreshTestCartNotice();
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startTestCartNotice
    );
  } else {
    startTestCartNotice();
  }
})();